import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import React, {useEffect, useRef, useState} from "react";
import {useFormik} from "formik";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import Loader from "../components/Loader";
import {UsersService} from "../services/UsersService";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {Button} from "primereact/button";
import {DepartmentService} from "../services/DepartmentService";
import {Toast} from "primereact/toast";

export default function UserEditWork() {
    const toast = useRef(null);
    const props = useParams()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [positions, setPositions] = useState([])
    const [groups, setGroups] = useState([])
    const [sending, setSending] = useState(true)

    const formik = useFormik({
        initialValues: {
          user_id: '',
          department_id: '',
          received: '',
            position_id: '',
            group_id: ''
        },
        validate: (data) => {
            const errors = {}

            if(!data.received){
                errors.received = 'Обязательное поле!'
            }
            if(!data.position_id){
                errors.position_id = 'Обязательное поле!'
            }

            console.log(errors)

            return errors
        },
        onSubmit: (data) => {
            // console.log(data)
            setSending(true)
            UsersService.UpdateWork(props.userId, currentDepartment, data).then((e) => {
                toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});
                setSending(false)
            })
        }
    })

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    useEffect(() => {
        UsersService.GetWork(props.userId, currentDepartment).then((r) => {
            if(r.received){
                r.received = new Date(r.received)
            }
            if(r.termination_date){
                r.termination_date = new Date(r.termination_date)
            }
            formik.setValues({...formik.values, ...r })
            setSending(false)
        })
        UsersService.GetPositions(currentDepartment).then((r) => {
            setPositions(r.items)
        })
        DepartmentService.getGroups({'filter': {'department_id': currentDepartment}}).then((r) => {
            setGroups(r.items)
        })
    }, []);


    return (
        <>
            <Toast ref={toast}></Toast>
            <div className="card">
                <div className="card-body">
                    {formik.values && !sending ?
                        <>
                            <h3 className={'m-b-30'}>Трудовой договор</h3>

                            <form className={'d-flex flex-column gap-2 '} onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={'d-flex flex-column gap-2'}>
                                            <label htmlFor="input_value">Дата приема</label>
                                            <Calendar
                                                name={'received'}
                                                value={formik.values.received}
                                                onChange={(e) => {
                                                    formik.setFieldValue('received', e.target.value);
                                                }}
                                                className={classNames({'p-invalid': isFormFieldInvalid('received')})}
                                            />

                                            {getFormErrorMessage('received')}

                                        </div>
                                    </div>
                                    <div className="col-md-6">

                                        <div className={'d-flex flex-column gap-2'}>
                                            <label htmlFor="input_value">Дата увольнения</label>
                                            <Calendar
                                                value={formik.values.termination_date}
                                                onChange={(e) => {
                                                    formik.setFieldValue('termination_date', e.target.value);
                                                }}
                                                className={classNames({'p-invalid': isFormFieldInvalid('termination_date')})}
                                            />

                                            {getFormErrorMessage('termination_date')}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={'d-flex flex-column gap-2'}>
                                            <label htmlFor="input_value">Должность</label>
                                            <Dropdown value={formik.values.position_id} options={positions.map((position) => {
                                                return {label: position.name, value: position.id}
                                            })}
                                                      onChange={(e) => formik.setFieldValue('position_id', e.target.value)}
                                            />

                                            {getFormErrorMessage('position_id')}

                                        </div>
                                    </div>
                                    <div className="col-md-6">

                                        <div className={'d-flex flex-column gap-2'}>
                                            <label htmlFor="input_value">Группа/Класс</label>
                                            <Dropdown value={formik.values.group_id} options={groups.map((group) => {
                                                return {label: group.name, value: group.id}
                                            })}
                                                      onChange={(e) => formik.setFieldValue('group_id', e.target.value)}
                                            />
                                            {getFormErrorMessage('group_id')}


                                        </div>
                                    </div>
                                </div>


                                <div className="d-flex flex-column align-self-start m-t-10">
                                    <Button type={'submit'} value={'Сохранить'}>Сохранить</Button>
                                </div>
                            </form>
                        </> : <Loader/>}
                </div>
            </div>
        </>
    )
}